export default "__VITE_ASSET__891d84e7__"